import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";

// Sentry is initialised lazily inside <SentryInit /> so it does not block
// the initial paint.  See src/components/providers/SentryInit.tsx.

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
